<template>
  <div
    class="d-flex mb-2"
    :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between'"
  >
    <div class="mb-2">
      <div class="titre-h1 pb-1">
        Bienvenue,
      </div>
      <div class="intro">
        {{ isUtilisateurAgrial ? 'Vous êtes sur l\'assistant de pilotage des cultures' : 'Vous êtes sur l\'assistant de pilotage de vos cultures' }}
      </div>
    </div>
    <v-card
      class="d-flex flex-nowrap pa-2"
      :class="$vuetify.breakpoint.mobile ? 'flex-column w-100' : ''"
      elevation="2"
      @click="toBag()"
    >
      <div :class="$vuetify.breakpoint.mobile ? '' : 'align-self-center'">
        <img
          alt="Logo BAG"
          class="mx-2 mr-5 mt-1"
          src="/images/logo_bag.svg"
        >
      </div>
      <div :class="$vuetify.breakpoint.mobile ? 'd-flex justify-space-between' : 'mt-3'">
        <span class="texte texte-gris-fonce ml-2 ml-md-0 mr-2">
          Besoin de vendre vos cultures ?
        </span>
        <v-icon
          color="primary"
          class="mr-4 mr-md-0"
        >
          mdi-open-in-new
        </v-icon>
      </div>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'TdbHeader',
  props: {
    isUtilisateurAgrial: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toBag () {
      window.open(
        window.PROPERTIES.get('URL_BOURSE_AUX_GRAINS').toString()
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}

.v-card--link::before {
  background: white !important;
}
</style>